export default {
  data() {
    return {
      recaptchaToken: null,
      recaptchaPendingCallback: null,
      recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    }
  },
  methods: {
    executeRecaptcha(callback) {
      if (this.recaptchaToken) {
        callback(this.recaptchaToken)
        return
      }
      this.recaptchaPendingCallback = callback
      this.$nextTick(() => {
        const widget = this.$refs.recaptcha
        if (!widget) {
          this.recaptchaPendingCallback = null
          return
        }
        const runExecute = () => widget.execute()
        if (widget.$widgetId !== undefined) {
          runExecute()
        } else {
          widget.$once('render', runExecute)
        }
      })
    },
    onRecaptchaVerify(token) {
      this.recaptchaToken = token
      if (this.recaptchaPendingCallback) {
        const callback = this.recaptchaPendingCallback
        this.recaptchaPendingCallback = null
        callback(token)
      }
    },
    onRecaptchaExpired() {
      this.recaptchaToken = null
      this.recaptchaPendingCallback = null
    },
    onRecaptchaError() {
      this.recaptchaToken = null
      this.recaptchaPendingCallback = null
    },
    resetRecaptcha() {
      this.recaptchaToken = null
      this.recaptchaPendingCallback = null
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
  },
}
